import { BuilderConfiguration,
  BuilderConfigurationElement,
  BuilderConfigurationElementOption,
  BuilderConfigurationFunction,
  BuilderElement,
  BuilderElementOption,
  BuilderGroupContent,
  BuilderGroups,
  OptionTypeDate }                                                                                                from '@/views/x-axis-report/report-edit/types/types';
import { XAxisReportPanelGroups }                                                                from '@/views/x-axis-report/report-edit/helpers/x-axis-report.variables';
import { ElementType }                                                                           from '@/helpers/variables';
import { getDateRangeEachDay, isElementLeadTime, isElementTypeDate, isGroupFilter, sortByOrder } from '@/views/x-axis-report/report-edit/helpers/x-axis.report-general.helpers';
import { ElementOptionStyle }                                                                    from '@/components/chart/chart-tooltip/chart-tooltip.types';
import { getElementType }                                                                        from '@/views/x-axis-report/report-edit/helpers/side-panel/x-axis-report-side-panel.helpers';
import { ObjectWithStringKeys }                                                                  from '@/types';

export const getConfigurationRequestBody = (configuration: ObjectWithStringKeys<BuilderConfiguration[]>, groups: BuilderGroups): ObjectWithStringKeys<BuilderConfiguration[]> => {
  let requestBody: ObjectWithStringKeys<BuilderConfiguration[]> = {};

  Object.values(XAxisReportPanelGroups)
    .forEach((group: XAxisReportPanelGroups) => {
      const defaultConfigurationWithStyles = configuration[ group ]
        .map((el: BuilderConfiguration) => {
          if (group === XAxisReportPanelGroups.FUNCTIONS) {
            const functionElement: BuilderGroupContent | undefined = (groups[ group ].data as BuilderGroupContent[])
              .find((a: BuilderGroupContent) => a.aggregationFunction === (el as BuilderConfigurationFunction).function);

            return {
              ...el,
              label: functionElement?.label ?? null,
              color: functionElement?.color || (el as BuilderConfigurationFunction).color,
              order: (functionElement?.order ?? el.order) ?? 0,
            };
          } if (isGroupFilter(group)) {
            const element = (el as BuilderConfigurationElement);
            const type: string = isElementLeadTime(element) ? ElementType.VALUE : getElementType(element);
            const options: BuilderConfigurationElementOption[] = isElementTypeDate(element)
              ? getDateRangeEachDay((element.options[ 0 ] as OptionTypeDate).min.toString(), (element.options[ 0 ] as OptionTypeDate).max.toString())
              : element.options;

            return {
              ...element,
              options,
              type,
            };
          }
          const element = (el as BuilderConfigurationElement);
          const panelElement: BuilderElement | undefined = (groups[ group ].data as BuilderGroupContent[])
            .find((a: BuilderGroupContent) => a.columnName === element.name) as BuilderElement;

          if (isElementTypeDate(element) || isElementLeadTime(element)) {
            return element;
          }

          return {
            ...element,
            leadElement: panelElement.leadElement ?? false,
            options: element.options.map((option: BuilderConfigurationElementOption) => {
              const elementOption = option as ElementOptionStyle;
              const opt: BuilderElementOption | undefined = (panelElement?.options as BuilderElementOption[])
                .find((panelElementOption: BuilderElementOption) => panelElementOption.name === elementOption.name);

              return {
                name: opt?.name || elementOption.name,
                color: opt?.color || elementOption.color,
                order: opt?.order ?? elementOption.order,
                label: opt?.label || elementOption.label,
              };
            })
              .sort(sortByOrder)
              .map((el: ElementOptionStyle, order: number) => ({
                ...el,
                order,
              })),
          };
        });

      requestBody = {
        ...requestBody,
        [ group ]: defaultConfigurationWithStyles,
      };
    });

  return requestBody;
};
